import { ArrowBack } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Button, Chip, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { truckImplementPartialHeader } from 'app/modules/dashboards/dashboard-truck-implement/components/header/truckImplementPartialHeader';
// import { useBetaVersion } from 'app/modules/dashboards/shared/BetaVersionContext';
import { showElement } from 'app/shared/util/data-utils';
import React from 'react';
import { Translate } from 'react-jhipster';
import { Link, useHistory } from 'react-router-dom';

interface PageHeaderProps {
  headingId: string;
  headingDataCy: string;
  contentKey: string;
  subtitle?: string;
  buttonTextKey?: string;
  match?: any;
  showButton?: boolean;
  showTruckDetail?: boolean;
  truckDetailProps?: any;
  onBackClick?: () => void;
  onBetaVersion?: boolean;
  redirectUrl?: string;
  loading?: boolean;
  urlButton?: string;
  actions?: React.ReactNode;
  extraActions?: React.ReactNode;
}

export const PageHeader = ({
  headingId,
  headingDataCy,
  contentKey,
  subtitle,
  buttonTextKey,
  match,
  showButton = true,
  showTruckDetail = false,
  truckDetailProps,
  onBackClick,
  onBetaVersion,
  loading,
  redirectUrl,
  urlButton = null,
  actions,
  extraActions,
}: PageHeaderProps) => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();

const defaultButtonSx = {
  borderRadius: '8px',
  textTransform: 'none',
  height: '42px',
  marginBottom: { xs: '0.35em', sm: '0' },
  '&:hover': {
    color: theme.palette.mode === 'dark' ? 'inherit' : 'secondary',
  },
};  

  return (
    <Grid
      container
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 1,
        flexWrap: 'nowrap',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <IconButton
          onClick={() => (onBackClick ? onBackClick() : history.goBack())}
          aria-label="goBack"
          size="large"
          sx={{ color: '#808080' }}
        >
          <ArrowBack />
        </IconButton>

        <Typography
          id={headingId}
          data-cy={headingDataCy}
          variant="h5"
          sx={{
            fontSize: '1.5rem',
            color: '#808080',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flexGrow: 1,
          }}
        >
          <Translate contentKey={contentKey} />
          {subtitle ? ` - ${subtitle}` : ''}
        </Typography>
      </Grid>

      <Grid
        item
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          columnGap: 1,
          mt: { xs: 0, sm: 1 },
          flexWrap: 'wrap',
        }}
      >
      {extraActions}
      {actions ? (
        React.Children.map(actions, child => {
          if (!React.isValidElement(child)) {
            return child;
          }

          if (child.type === React.Fragment) {
            return React.Children.map(child.props.children, fragmentChild => {
              if (!React.isValidElement(fragmentChild)) {
                return fragmentChild;
              }

              return React.cloneElement(fragmentChild as React.ReactElement<any>, {
                sx: {
                  ...defaultButtonSx,
                  ...((fragmentChild as React.ReactElement<any>).props.sx || {}),
                },
              });
            });
          }

          return React.cloneElement(child as React.ReactElement<any>, {
            sx: {
              ...defaultButtonSx,
              ...((child as React.ReactElement<any>).props.sx || {}),
            },
          });
        })
      ) : (
          <Button
            component={Link}
            color="secondary"
            variant="contained"
            to={
              showButton
                ? urlButton
                  ? urlButton.startsWith('/')
                    ? urlButton
                    : `${match.url}/${urlButton}`
                  : `${match.url}/new`
                : ''
            }
            id="jh-create-entity"
            data-cy="entityCreateButton"
            sx={{
              ...showElement(showButton),
              ...defaultButtonSx,
            }}
          >
            {!isXsScreen ? (
              <Translate contentKey={showButton ? buttonTextKey : ''} />
            ) : (
              <AddIcon fontSize="small" />
            )}
          </Button>
        )}

        {showTruckDetail && truckImplementPartialHeader(truckDetailProps)}
      </Grid>
    </Grid>
  );
};